import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const content = {
  de: {
    title: 'Allgemeine Geschäftsbedingungen',
    back: 'Zurück',
    intro: 'Diese AGB regeln die Nutzung der Website enbet-consulting.de sowie aller darüber angebotenen Dienste (Chatbot, Terminbuchung, Beratungsleistungen).',
    sections: [
      {
        heading: '§1 Geltungsbereich',
        text: `Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Vertragsbeziehungen zwischen der EnBet Consulting UG (haftungsbeschränkt), Im Tal 30, 34270 Schauenburg (nachfolgend „Anbieter") und Nutzern der Website enbet-consulting.de sowie Kunden, die Beratungsleistungen in Anspruch nehmen.

Abweichende Bedingungen des Kunden werden nur dann Vertragsbestandteil, wenn der Anbieter ihrer Geltung schriftlich zustimmt.`
      },
      {
        heading: '§2 Vertragsgegenstand',
        text: `Der Anbieter erbringt Beratungsleistungen im Bereich der praktischen Einführung von Künstlicher Intelligenz (KI) im stationären Handel, im Filialgeschäft und in serviceintensiven Branchen.

Die konkreten Leistungen werden individuell vereinbart und in einem separaten Angebot oder Beratungsvertrag festgehalten.`
      },
      {
        heading: '§3 Vertragsschluss',
        text: `Die Darstellung der Leistungen auf der Website stellt kein verbindliches Angebot dar, sondern eine Aufforderung zur Abgabe eines Angebots durch den Kunden.

Erstkontakte (Chatbot, Buchungs-Widget, Kontaktformular) sind unverbindlich. Ein Beratungsvertrag kommt erst durch schriftliche Auftragsbestätigung des Anbieters zustande.

Das kostenlose Strategiegespräch ist kein Vertrag im Sinne dieser AGB, sondern dient dem unverbindlichen Kennenlernen.`
      },
      {
        heading: '§4 Nutzung des Chatbots und Buchungs-Widgets',
        text: `Die Nutzung des Chatbots „Tom" und des Buchungs-Widgets ist kostenlos.

Mit der Nutzung erklären Sie sich einverstanden, dass:
- Ihre Eingaben durch einen KI-Dienst (Anthropic Claude) verarbeitet werden
- Ihre Kontaktdaten zur Bearbeitung Ihrer Anfrage gespeichert werden
- Bei Terminbuchung Ihre Daten an Google (Calendar/Meet) übermittelt werden

Details zur Datenverarbeitung finden Sie in der Datenschutzerklärung.

Missbräuchliche Nutzung (Spam, automatisierte Anfragen, Beleidigungen, illegale Inhalte) führt zum Ausschluss von der Nutzung.`
      },
      {
        heading: '§5 Beratungsleistungen',
        text: `Beratungsleistungen werden auf Grundlage eines separat geschlossenen Beratungsvertrags erbracht.

Der Anbieter schuldet eine sorgfältige Beratung nach bestem Wissen, jedoch keinen bestimmten wirtschaftlichen Erfolg. Geschäftserfolge, ROI-Versprechen oder konkrete Umsatzsteigerungen werden ausdrücklich nicht garantiert.

Der Kunde stellt dem Anbieter alle für die Leistungserbringung notwendigen Informationen rechtzeitig und vollständig zur Verfügung.`
      },
      {
        heading: '§6 Preise und Zahlungsbedingungen',
        text: `Die Preise ergeben sich aus dem individuellen Angebot. Alle Preise verstehen sich zzgl. der jeweils geltenden gesetzlichen Umsatzsteuer.

Rechnungen sind innerhalb von 14 Tagen nach Erhalt ohne Abzug zur Zahlung fällig.

Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz zu berechnen.`
      },
      {
        heading: '§7 Haftung',
        text: `Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, die auf einer vorsätzlichen oder fahrlässigen Pflichtverletzung beruhen, sowie für sonstige Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen.

Für leicht fahrlässige Pflichtverletzungen haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten). Die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden begrenzt.

Die Haftung für Folgeschäden, entgangenen Gewinn oder mittelbare Schäden aus der Umsetzung der Beratungsempfehlungen ist ausgeschlossen, soweit gesetzlich zulässig.

Der Anbieter haftet nicht für Verfügbarkeit oder Funktionsfähigkeit von Drittanbieter-Diensten (z.B. Google Calendar, Anthropic).`
      },
      {
        heading: '§8 Urheberrecht und Nutzungsrechte',
        text: `Alle vom Anbieter erstellten Konzepte, Roadmaps, Schulungsunterlagen und sonstigen Arbeitsergebnisse sind urheberrechtlich geschützt.

Der Kunde erhält ein einfaches, nicht übertragbares Nutzungsrecht für interne Zwecke. Die Weitergabe an Dritte oder kommerzielle Verwertung bedarf der schriftlichen Zustimmung des Anbieters.`
      },
      {
        heading: '§9 Vertraulichkeit',
        text: `Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit erlangten vertraulichen Informationen geheim zu halten und nicht an Dritte weiterzugeben.

Diese Pflicht besteht auch nach Beendigung der Zusammenarbeit fort.`
      },
      {
        heading: '§10 Widerrufsrecht für Verbraucher',
        text: `Sofern Sie Verbraucher im Sinne des § 13 BGB sind, steht Ihnen bei Fernabsatzverträgen ein gesetzliches Widerrufsrecht zu. Bei Verträgen über Beratungsleistungen erlischt das Widerrufsrecht, wenn die Leistung mit Ihrer ausdrücklichen Zustimmung vor Ablauf der Widerrufsfrist vollständig erbracht wurde.

Unsere Angebote richten sich überwiegend an Unternehmer im Sinne des § 14 BGB. In diesem Fall besteht kein Widerrufsrecht.`
      },
      {
        heading: '§11 Datenschutz',
        text: `Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Details zur Datenverarbeitung entnehmen Sie bitte unserer separaten Datenschutzerklärung.`
      },
      {
        heading: '§12 Schlussbestimmungen',
        text: `Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.

Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist — soweit gesetzlich zulässig — Kassel.

Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.

Stand: Mai 2026`
      },
    ],
  },
  en: {
    title: 'Terms and Conditions',
    back: 'Back',
    intro: 'These Terms govern the use of the website enbet-consulting.de as well as all services offered through it (chatbot, appointment booking, consulting services).',
    sections: [
      {
        heading: '§1 Scope',
        text: `These General Terms and Conditions (T&C) apply to all contractual relationships between EnBet Consulting UG (haftungsbeschränkt), Im Tal 30, 34270 Schauenburg, Germany (hereinafter "Provider") and users of the website enbet-consulting.de as well as customers using consulting services.

Deviating conditions of the customer only become part of the contract if the Provider agrees to their validity in writing.`
      },
      {
        heading: '§2 Subject of the Contract',
        text: `The Provider delivers consulting services in the field of practical introduction of Artificial Intelligence (AI) in brick-and-mortar retail, chain stores and service-intensive industries.

The specific services are individually agreed upon and recorded in a separate offer or consulting contract.`
      },
      {
        heading: '§3 Conclusion of Contract',
        text: `The presentation of services on the website does not constitute a binding offer, but an invitation to submit an offer by the customer.

Initial contacts (chatbot, booking widget, contact form) are non-binding. A consulting contract is only concluded through written order confirmation by the Provider.

The free strategy call is not a contract within the meaning of these T&C, but serves the purpose of non-binding initial contact.`
      },
      {
        heading: '§4 Use of Chatbot and Booking Widget',
        text: `Use of the chatbot "Tom" and the booking widget is free of charge.

By using these services, you agree that:
- Your inputs are processed by an AI service (Anthropic Claude)
- Your contact details are stored for processing your inquiry
- When booking an appointment, your data is transmitted to Google (Calendar/Meet)

Details on data processing can be found in the privacy policy.

Abusive use (spam, automated requests, insults, illegal content) leads to exclusion from use.`
      },
      {
        heading: '§5 Consulting Services',
        text: `Consulting services are provided on the basis of a separately concluded consulting contract.

The Provider owes diligent consulting according to best knowledge, but no specific economic success. Business success, ROI promises or specific revenue increases are explicitly not guaranteed.

The customer provides the Provider with all information necessary for the provision of services in a timely and complete manner.`
      },
      {
        heading: '§6 Prices and Payment Terms',
        text: `Prices result from the individual offer. All prices are exclusive of applicable statutory VAT.

Invoices are due for payment within 14 days of receipt without deduction.

In case of late payment, the Provider is entitled to charge default interest of 9 percentage points above the base interest rate.`
      },
      {
        heading: '§7 Liability',
        text: `The Provider is liable without limitation for damages resulting from injury to life, body or health based on intentional or negligent breach of duty, as well as for other damages based on intentional or grossly negligent breach of duty.

For slightly negligent breaches of duty, the Provider is only liable for breach of essential contractual obligations (cardinal duties). Liability is limited to the typical foreseeable contractual damage in this case.

Liability for consequential damages, lost profit or indirect damages from the implementation of consulting recommendations is excluded as far as legally permissible.

The Provider is not liable for availability or functionality of third-party services (e.g. Google Calendar, Anthropic).`
      },
      {
        heading: '§8 Copyright and Usage Rights',
        text: `All concepts, roadmaps, training materials and other work results created by the Provider are protected by copyright.

The customer receives a simple, non-transferable usage right for internal purposes. Distribution to third parties or commercial exploitation requires the Provider's written consent.`
      },
      {
        heading: '§9 Confidentiality',
        text: `Both parties undertake to keep all confidential information obtained in the course of cooperation secret and not to disclose it to third parties.

This obligation continues even after termination of cooperation.`
      },
      {
        heading: '§10 Right of Withdrawal for Consumers',
        text: `If you are a consumer within the meaning of § 13 BGB (German Civil Code), you have a statutory right of withdrawal for distance contracts. For contracts on consulting services, the right of withdrawal expires if the service has been fully provided with your express consent before the end of the withdrawal period.

Our services are primarily aimed at entrepreneurs within the meaning of § 14 BGB. In this case, there is no right of withdrawal.`
      },
      {
        heading: '§11 Data Protection',
        text: `The protection of your personal data is important to us. For details on data processing, please refer to our separate privacy policy.`
      },
      {
        heading: '§12 Final Provisions',
        text: `German law applies, excluding the UN Convention on Contracts for the International Sale of Goods.

The exclusive place of jurisdiction for all disputes arising from or in connection with these T&C is — as far as legally permissible — Kassel, Germany.

Should individual provisions of these T&C be or become invalid, the validity of the remaining provisions shall remain unaffected.

Status: May 2026`
      },
    ],
  },
};

export default function AGBPage({ onClose }) {
  const { lang } = useLanguage();
  const c = content[lang];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] bg-white overflow-y-auto"
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-[#1f1f1f]/60 hover:text-[#1f1f1f] mb-10 transition-colors"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          <ArrowLeft size={16} /> {c.back}
        </button>
        <h1 className="text-[#1f1f1f] text-3xl md:text-4xl font-bold uppercase tracking-tight leading-[1.3] mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
          {c.title}
        </h1>
        <p className="text-[#1f1f1f]/70 text-base leading-relaxed mb-12" style={{ fontFamily: "'Manrope', sans-serif" }}>
          {c.intro}
        </p>
        <div className="space-y-8">
          {c.sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-[#1f1f1f] text-xl font-bold uppercase tracking-tight mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {s.heading}
              </h2>
              <p className="text-[#1f1f1f]/70 text-base leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Manrope', sans-serif" }}>
                {s.text}
              </p>
            </section>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
